/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'overview',
        title: 'Überblick',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'overview.emergency-call-status',
                title: 'Notruf',
                type: 'basic',
                // icon: 'heroicons_outline:clipboard-document-check',
                icon: 'notfallkontakte',
                link: '/overview/emergency',
            },
            {
                id: 'overview.health',
                title: 'user-health-stats',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar-square',
                link: '/overview/user-health-stats',
            },
            {
                id: 'overview.chat',
                title: 'CHAT',
                type: 'basic',
                icon: 'heroicons_outline:chat-bubble-bottom-center-text',
                link: '/overview/chat',
            },
            {
                id: 'overview.task',
                title: 'TASK',
                type: 'basic',
                icon: 'heroicons_outline:rectangle-stack',
                link: '/overview/task',
            },
            {
                id: 'overview.calendar',
                title: 'CALENDAR',
                type: 'basic',
                icon: 'heroicons_outline:calendar',
                link: '/overview/calendar',
            },
            // {
            //     id: 'overview.health',
            //     title: 'Gesundheit',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/overview/health',
            // },
            // {
            //     id: 'overview.day-view',
            //     title: 'Überblick Tagesablauf',
            //     type: 'basic',
            //     icon: 'heroicons_outline:banknotes',
            //     link: '/overview/day-view',
            // },
        ],
    },
    // {
    //     id: 'functions',
    //     title: 'Funktionen (Functions)',
    //     // subtitle: 'Unique dashboard designs',
    //     type: 'group',
    //     icon: 'heroicons_outline:home',
    //     children: [
    //         {
    //             id: 'functions.calls',
    //             title: 'Anrufe (Calls)',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/functions/calls',
    //         },
    //         {
    //             id: 'functions.chat',
    //             title: 'Chats (Chat)',
    //             type: 'basic',
    //             icon: 'heroicons_outline:chart-pie',
    //             link: '/functions/chat',
    //         },
    //         {
    //             id: 'functions.calendar',
    //             title: 'Kalender (Calendar)',
    //             type: 'basic',
    //             icon: 'heroicons_outline:banknotes',
    //             link: '/functions/calendar',
    //         },
    //         {
    //             id: 'functions.notes',
    //             title: 'Notizen (Notes)',
    //             type: 'basic',
    //             icon: 'heroicons_outline:banknotes',
    //             link: '/functions/notes',
    //         },
    //         {
    //             id: 'functions.tasks',
    //             title: 'Aufgaben (Tasks)',
    //             type: 'basic',
    //             icon: 'heroicons_outline:banknotes',
    //             link: '/functions/tasks',
    //         },
    //     ],
    // },
    {
        id: 'configuration-user',
        title: 'Nutzer-Daten (Personal settings)',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'configuration-user.personal',
                title: 'Persönliche Daten (Personal)',
                type: 'basic',
                icon: 'persoenlich',
                link: '/configuration-user/personal',
            },
            {
                id: 'configuration-user.health',
                title: 'Gesundheitsdaten (Health setttings)',
                type: 'basic',
                icon: 'gesundheit02',
                link: '/configuration-user/health',
            },
            {
                id: 'configuration-user.contacts',
                title: 'Kontakte (Contacts)',
                type: 'basic',
                icon: 'kontakte',
                link: '/configuration-user/contacts',
            },
            {
                id: 'configuration-user.create-new-user',
                title: 'Create new user',
                type: 'basic',
                icon: 'create',
                link: '/configuration-user/create-new-user',
            },
            {
                id: 'configuration-user.account',
                title: 'ACCOUNT',
                type: 'basic',
                icon: 'heroicons_outline:user-circle',
                link: '/configuration-user/account',
            },
            // {
            //     id: 'personal-settings.my-caretakers',
            //     title: 'my-caretakers',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/personal-settings/my-caretakers',
            // },
            // {
            //     id: 'personal-settings.caregiver',
            //     title: 'caregiver',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/personal-settings/my-caregiver',
            // },
            // {
            //     id: 'personal-settings.device-management',
            //     title: 'Geräte-Verwaltung (Device Management)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/personal-settings/device-management',
            // },
            // {
            //     id: 'personal-settings.payment',
            //     title: 'Zahlungsdaten (Payment)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:banknotes',
            //     link: '/personal-settings/payment',
            // },
            // {
            //     id: 'personal-settings.settings',
            //     title: 'Settings',
            //     type: 'basic',
            //     icon: 'heroicons_outline:banknotes',
            //     link: '/personal-settings/settings/device-management',
            // },
        ],
    },
    {
        id: 'service-settings',
        title: 'Konfiguration Dienste (Service settings)',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'service-settings.emergency',
                title: 'Emergency',
                type: 'basic',
                icon: 'notrufdienst',
                link: '/service-settings/emergency-call',
            },
            // {
            //     id: 'service-settings.automatic-emergency',
            //     title: 'Automatischer Notruf (Automatic Emergency Call)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/service-settings/automatic-emergency',
            // },
            {
                id: 'service-settings.geo-protection',
                title: 'Geo protection',
                type: 'basic',
                icon: 'orientierung',
                link: '/service-settings/geo-protection',
            },
            {
                id: 'service-settings.drink',
                title: 'Trinkplan (Drinking Plan)',
                type: 'basic',
                icon: 'trinken',
                link: '/service-settings/drinking-plan',
            },
            {
                id: 'service-settings.movement',
                title: 'Exercise Plane',
                type: 'basic',
                icon: 'bewegung',
                link: '/service-settings/exercise-plan',
            },
            {
                id: 'service-settings.exercises',
                title: 'Exercises',
                type: 'basic',
                icon: 'uebungen',
                link: '/service-settings/exercises',
            },
            {
                id: 'service-settings.knowledge',
                title: 'Knowledge',
                type: 'basic',
                icon: 'wissen',
                link: '/service-settings/knowledge',
            },
            {
                id: 'service-settings.routines',
                title: 'Routinenplan (Routine Plan)',
                type: 'basic',
                icon: 'routine02',
                link: '/service-settings/routine-plan',
            },
            {
                id: 'service-settings.medication-plan',
                title: 'Medikationsplan (Medication Plan)',
                type: 'basic',
                icon: 'medPlan',
                link: '/service-settings/medication-plan',
            },
            {
                id: 'service-settings.questionnaire',
                title: 'Questionnaires',
                type: 'basic',
                icon: 'fragebogen',
                link: '/service-settings/questionnaire',
            },
            {
                id: 'service-settings.general-reminder',
                title: 'Allgemeine Erinnerungen / Termine (General Reminder/ Appointments)',
                type: 'basic',
                icon: 'termine',
                link: '/service-settings/general-reminder',
            },
            {
                id: 'service-settings.notes',
                title: 'Notes',
                type: 'basic',
                icon: 'notes',
                link: '/service-settings/notes',
            },
        ],
    },
    {
        id: 'device-configuration',
        title: 'Device configuration',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:cog-6-tooth',
        children: [
            // {
            //     id: 'device-configuration.device-configuration',
            //     title: 'Settings',
            //     type: 'basic',
            //     icon: 'heroicons_outline:cog-6-tooth',
            //     link: '/configuration-user/settings/device-management',
            // },
            {
                id: 'device-configuration.device-management',
                title: 'Device management',
                type: 'basic',
                icon: 'heroicons_outline:device-tablet',
                link: '/device-configuration/device-management',
            },
            {
                id: 'device-configuration.set-wlan',
                title: 'Set WLAN',
                type: 'basic',
                icon: 'heroicons_outline:wifi',
                link: '/device-configuration/set-wlan',
            },
            {
                id: 'device-configuration.share-location',
                title: 'Share location',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                link: '/device-configuration/location',
            },
        ],
    },
    // {
    //     id: 'worth-knowing',
    //     title: 'worth-knowing',
    //     // subtitle: 'Unique dashboard designs',
    //     type: 'group',
    //     icon: 'heroicons_outline:home',
    //     children: [
    //         {
    //             id: 'worth-knowing.AP_AP',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_AP',
    //         },
    //         {
    //             id: 'worth-knowing.AP_CE',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_CE',
    //         },
    //         {
    //             id: 'worth-knowing.AP_Manual',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_Manual',
    //         },
    //         {
    //             id: 'worth-knowing.AP_compatibility',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_compatibility',
    //         },
    //         {
    //             id: 'worth-knowing.AP_DS_web',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_DS_web',
    //         },
    //         {
    //             id: 'worth-knowing.AP_NB',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_NB',
    //         },
    //         {
    //             id: 'worth-knowing.AP_Impressum',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_Impressum',
    //         },
    //         {
    //             id: 'worth-knowing.AP_FAQ',
    //             title: 'Über ALMA PHIL',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-document-check',
    //             link: '/worth-knowing/AP_FAQ',
    //         },
    //     ],
    // },
    {
        id: 'support',
        title: 'Support',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            // {
            //     id: 'support.academy',
            //     title: 'Wissen (Academy)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:clipboard-document-check',
            //     link: '/support/academy',
            // },
            // {
            //     id: 'support.help-center',
            //     title: 'Hilfezentrale (Help center)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/support/help-center',
            // },
            {
                id: 'support.help-center',
                title: 'Help Center',
                type: 'basic',
                icon: 'heroicons_outline:information-circle',
                link: '/support/help-center',
            },
            {
                id: 'support.help-center.instructions',
                title: 'Guidelines',
                type: 'basic',
                icon: 'anleitungen02',
                // link: '/support/help-center/guidelines',
                link: '/support/help-center/guidelines/video',
            },
            {
                id: 'support.help-center.legal-information-literature',
                title: 'Guidelines',
                type: 'basic',
                icon: 'section-sign',
                link: '/support/help-center/guidelines/legal',
            },
            {
                id: 'support.help-center.faq',
                title: 'FAQ',
                type: 'basic',
                icon: 'faq',
                link: '/support/help-center/faq',
            },
            {
                id: 'support.help-center.contact-us',
                title: 'Contact us',
                type: 'basic',
                icon: 'heroicons_outline:envelope-open',
                link: '/support/help-center/contact-us',
            },
            // {
            //     id: 'support.file-manager',
            //     title: 'Dateien (File manager)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:banknotes',
            //     link: '/support/file-manager',
            // },
        ],
    },
    {
        id: 'admin',
        title: 'Admin',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            // {
            //     id: 'admin.activities',
            //     title: 'Aktivitäten (Activities)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:clipboard-document-check',
            //     link: '/admin/activities',
            // },
            {
                // id: 'admin.user-table',
                id: 'admin.user',
                title: 'Benutzertabelle (User Table)',
                type: 'basic',
                icon: 'nutzer',
                link: '/admin/user-table',
            },
            {
                id: 'admin.devices',
                title: 'Uhrentabelle (Watch Table)',
                type: 'basic',
                icon: 'geraete02',
                link: '/admin/watch-table',
            },
            {
                id: 'admin.insights',
                title: 'Geräte Nutzung (device-insights)',
                type: 'basic',
                icon: 'heroicons_solid:eye',
                link: '/admin/device-insights',
            },
            {
                id: 'admin.export-csv',
                title: 'Export csv',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/admin/export-csv',
            },
            // {
            //     id: 'admin.emergenc-tracker',
            //     title: 'Notruf-Tracker (Emergenc Tracker)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/admin/emergenc-tracker',
            // },
            // {
            //     id: 'admin.emergency-center',
            //     title: 'Notruf-Zentrale (Emergency center)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:banknotes',
            //     link: '/admin/emergency-center',
            // },
            // {
            //     id: 'admin.b2b-admin',
            //     title: 'B2B Admin',
            //     type: 'basic',
            //     icon: 'heroicons_outline:banknotes',
            //     link: '/admin/b2b-admin',
            // },
            // {
            //     id: 'admin.watch-inflow',
            //     title: 'Uhrenerfassung (Watch Inflow)',
            //     type: 'basic',
            //     icon: 'heroicons_outline:pencil-square',
            //     link: '/admin/watch-inflow',
            // },
            /*{
                id: 'admin.esim-knox',
                title: 'eSIM/KNOX zuweisen (Assign eSIM/KNOX)',
                type: 'basic',
                icon: 'heroicons_outline:pencil-square',
                link: '/admin/esim-knox',
            },
            {
                id: 'admin.shipping',
                title: 'Versand (Shipping)',
                type: 'basic',
                icon: 'heroicons_outline:paper-airplane',
                link: '/admin/shipping',
            },*/
        ],
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        tooltip: 'Dashboards',
        type: 'aside',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        tooltip: 'Apps',
        type: 'aside',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        tooltip: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        tooltip: 'UI',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation',
        tooltip: 'Navigation',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARDS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'APPS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'others',
        title: 'OTHERS',
        type: 'group',
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'User Interface',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation Features',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'group',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'group',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        type: 'group',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Misc',
        type: 'group',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
